<template>
  <rich-text-editor
    v-model="val"
    class="flex overflow-hidden"
    :label="label"
    :height="height"
    inline-row
    bold-allowed
    italic-allowed
    :error-messages="errors"
  >
    <template #menubar="{editor}">
      <v-menu offset-y>
        <template #activator="{ on }">
          <v-btn
            class="mr-2"
            color="primary"
            outlined
            small
            v-on="on"
          >
            <v-icon x-small>
              mdi-dots-horizontal
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-subheader style="height: 32px">
            {{ $t('button.insert_placeholder') }}
          </v-subheader>
          <v-list-item
            v-for="(item, i) in placeholders"
            :key="i"
            @click="editor?.commands.insertHandlebar({ id: `${item.id}`, label: item.name })"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
          <v-divider v-if="$slots['menu-items']" />
          <slot name="menu-items" />
        </v-list>
      </v-menu>
    </template>
  </rich-text-editor>
</template>

<script lang="ts" setup>
import RichTextEditor from '@/components/editors/RichTextEditor.vue';
import MessageHandlebar from '@/model/MessageHandlebar';
import { PropType, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';

const props = defineProps({
  placeholders: { type: Object as PropType<Array<MessageHandlebar>>, required: true },
  height: { type: String, required: false, default: '200px' },
  label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  value: { type: String as PropType<string>, required: true },
});

const emit = defineEmits<{(e: 'input', event: string): void}>();
const errors = ref([]);

const val = ref(props.value);

watch(() => props.value, () => { val.value = props.value; });

watch(val, () => emit('input', val.value));
</script>
